import locationsData from "./locations.json";
import servicesData from "./services.json";

export const SITE = {
  name: "Xtreme Protection",
  tagline: "England Security Services",
  fullName: "Xtreme Protection — Security Services Across England",
  phone: "+44 2046 402840",
  phoneHref: "tel:+442046402840",
  email: "admin@xtremeprotection.uk",
  emailHref: "mailto:admin@xtremeprotection.uk",
  domain: "https://englandguards.co.uk",
  address: "20 Hylton Rd, Sunderland SR4 7AA",
  mapsUrl: "https://maps.app.goo.gl/vcRagwXVeCiEonm3A",
  mapsEntityUrl:
    "https://maps.google.com/maps?q=Xtreme+Protection,+20+Hylton+Rd,+Sunderland+SR4+7AA&ftid=0x487e67c793d6fafb:0x6c2f2222010bfd1e",
};

export const LOCATIONS = locationsData;
export const SERVICES = servicesData;

export const REGION_ORDER = [
  "London",
  "South East England",
  "South West England",
  "East of England",
  "East Midlands",
  "West Midlands",
  "Yorkshire and the Humber",
  "North West England",
  "North East England",
];

export const getLocation = (slug) => LOCATIONS.find((l) => l.slug === slug);
export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
export const locationsByRegion = (region) =>
  LOCATIONS.filter((l) => l.region === region);
export const nearbyLocations = (loc, n = 6) =>
  LOCATIONS.filter((l) => l.region === loc.region && l.slug !== loc.slug).slice(0, n);
export const FEATURED_LOCATIONS = LOCATIONS.filter((l) => l.featured);

export const hash = (str) => {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (Math.imul(h, 31) + str.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
};

export const findLocation = (q) => {
  const s = String(q || "").trim().toLowerCase();
  if (!s) return null;
  return (
    LOCATIONS.find((l) => l.name.toLowerCase() === s) ||
    LOCATIONS.find((l) => l.slug === s) ||
    LOCATIONS.find((l) => l.name.toLowerCase().startsWith(s)) ||
    LOCATIONS.find((l) => l.name.toLowerCase().includes(s)) ||
    null
  );
};

export const IMAGES = {
  hero: {
    url: "https://images.unsplash.com/photo-1520114878144-6123749968dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxMb25kb24lMjBuaWdodCUyMGNpdHklMjBza3lsaW5lJTIwZGFya3xlbnwwfHx8fDE3OTE2MDE0OTZ8MA&ixlib=rb-4.1.0&q=85&w=2000",
    alt: "Tower Bridge and the London skyline at dusk",
  },
  guards: [
    { url: "https://images.unsplash.com/photo-1652739758426-56a564265f9e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Uniformed security officer on night patrol in an urban area" },
    { url: "https://images.unsplash.com/photo-1566245024852-04fbf7842ce9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Professional SIA security officer in dark uniform" },
    { url: "https://images.unsplash.com/photo-1517913451214-e22ce660e086?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Security officer conducting a perimeter patrol check" },
    { url: "https://images.unsplash.com/flagged/photo-1570343271132-8949dd284a04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "High-visibility manned security guard on site duty" },
  ],
  cctv: [
    { url: "https://images.unsplash.com/photo-1708807472445-d33589e6b090?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "CCTV control room operator in front of a security monitor wall" },
    { url: "https://images.unsplash.com/photo-1581089781785-603411fa81e5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Professional monitoring desk with surveillance screens" },
  ],
  patrol: [
    { url: "https://images.unsplash.com/photo-1508974239320-0a029497e820?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Mobile security patrol vehicle at night" },
    { url: "https://images.unsplash.com/photo-1541899481282-d53bffe3c35d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Night patrol vehicle on a key holding and alarm response inspection" },
  ],
  event: [
    { url: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Night event crowd with security perimeter at a live stage" },
    { url: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Event security and crowd safety management at a concert" },
  ],
  construction: [
    { url: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Construction site under night floodlights" },
    { url: "https://images.unsplash.com/photo-1541888946425-d0fbb186a5b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Industrial crane and building development site at night" },
  ],
  k9: [
    { url: "https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Trained K9 security dog on guard duty with handler" },
    { url: "https://images.unsplash.com/photo-1537151608828-ea2b11777ee8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "German Shepherd security dog and handler patrol team" },
  ],
  corporate: [
    { url: "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Modern corporate office lobby with front of house concierge" },
    { url: "https://images.unsplash.com/photo-1497215728101-856f4ea42174?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Corporate reception desk with front-of-house security" },
  ],
  retail: [
    { url: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "High-end retail storefront protected by loss prevention security" },
    { url: "https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Shopping centre retail floor with security officer presence" },
  ],
  warehouse: [
    { url: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Large industrial logistics warehouse under night guarding" },
    { url: "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400", alt: "Industrial depot with perimeter security" },
  ],
};

export const serviceImage = (svc, seed = 0) => {
  const pool = IMAGES[svc.image] || IMAGES.guards;
  return pool[seed % pool.length];
};

export const KEYWORDS = [
  "Manned Guarding",
  "Door Supervisors",
  "CCTV Monitoring",
  "Mobile Security Patrols",
  "Event Security",
  "Construction Site Security",
  "Retail Security",
  "Corporate Security",
  "Concierge Security",
  "Key Holding & Alarm Response",
  "Close Protection",
  "Warehouse Security",
  "K9 Security Dog Handlers",
  "Vacant Property Security",
  "Hotel Security",
  "Hospital Security",
  "School & Campus Security",
  "SIA Licensed Guards",
  "24 Hour Security",
  "Security Company England",
];

export const HOME_FAQS = [
  {
    q: "What security services does Xtreme Protection provide in England?",
    a: "Seventeen specialist services, delivered nationwide: manned guarding, door supervision, CCTV monitoring, mobile patrols, event security, construction site security, retail and corporate security, concierge officers, key holding with alarm response, close protection, warehouse and industrial guarding, K9 dog units, vacant property protection, and security for hotels, hospitals and schools. Every officer is SIA licensed and vetted to BS 7858.",
  },
  {
    q: "Which parts of England do you cover?",
    a: "More than 120 towns and cities across all nine English regions — from London and the South East to the North West and North East. Regional teams are coordinated around the clock by our national command centre.",
  },
  {
    q: "Are your security officers SIA licensed?",
    a: "Always. Every officer carries the correct Security Industry Authority licence for their role, has passed BS 7858 background screening, holds first-aid training and works to written, site-specific assignment instructions.",
  },
  {
    q: "How quickly can security be deployed?",
    a: "Urgent guarding requests are typically filled within 24 hours. Keyholding and patrol contracts can start straight away, and rapid-deployment CCTV towers are normally installed within a few days of the site survey.",
  },
  {
    q: "Do you provide 24 hour security?",
    a: "Yes — 24 hours a day, 365 days a year. Static guards, mobile patrols, CCTV monitoring and alarm response all run around the clock, coordinated from our England command centre.",
  },
  {
    q: "What industries do you specialise in?",
    a: "Construction and housebuilding, retail and shopping centres, logistics and distribution, offices and business parks, hospitality and licensed venues, healthcare and NHS sites, and the education sector. Every package is designed from a fresh risk assessment, never a template.",
  },
];

export const INDUSTRY_LINKS = [
  { name: "Security Industry Authority (SIA)", url: "https://www.gov.uk/government/organisations/security-industry-authority" },
  { name: "British Security Industry Association", url: "https://www.bsia.co.uk" },
  { name: "SIA Licence Checker", url: "https://services.sia.homeoffice.gov.uk/PublicRegister" },
  { name: "GOV.UK — Business Crime Prevention", url: "https://www.gov.uk/government/collections/crime-prevention" },
];
